var _rect, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillHoverYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 15,
    rx: 7.5,
    fill: "#FDFDFE",
    stroke: "#FFD953"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_5702_17709",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 24,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2,
    y: 1,
    width: 24,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C5.68629 2 3 4.68629 3 8C3 11.3137 5.68629 14 9 14H13L13 2H9ZM15 2L15 14H19C22.3137 14 25 11.3137 25 8C25 4.68629 22.3137 2 19 2H15Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C5.68629 2 3 4.68629 3 8C3 11.3137 5.68629 14 9 14H13L13 2H9ZM15 2L15 14H19C22.3137 14 25 11.3137 25 8C25 4.68629 22.3137 2 19 2H15Z",
    fill: "#FFD953"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14V15H14V14H13ZM13 2L14 2V1H13V2ZM15 2V1H14V2L15 2ZM15 14H14V15H15V14ZM4 8C4 5.23858 6.23858 3 9 3V1C5.13401 1 2 4.13401 2 8H4ZM9 13C6.23858 13 4 10.7614 4 8H2C2 11.866 5.13401 15 9 15V13ZM13 13H9V15H13V13ZM14 14L14 2L12 2L12 14H14ZM9 3H13V1H9V3ZM14 2L14 14H16L16 2L14 2ZM19 13H15V15H19V13ZM24 8C24 10.7614 21.7614 13 19 13V15C22.866 15 26 11.866 26 8H24ZM19 3C21.7614 3 24 5.23858 24 8H26C26 4.13401 22.866 1 19 1V3ZM15 3H19V1H15V3Z",
    fill: "#FDFDFE",
    mask: "url(#path-2-outside-1_5702_17709)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillHoverYellow);
export default __webpack_public_path__ + "static/media/pill-hover-yellow.c8cbb01f54c28b49307c5334da08599c.svg";
export { ForwardRef as ReactComponent };